import { createSlice } from "@reduxjs/toolkit"
import { CC } from "../../../constants/reducer_names"

const initialState={
    closeCaptionText: [],
    ccBtns: false,
    showOriginalText:false,
    fontSize:""
}

const ccSlice=createSlice({
    name:CC,
    initialState,
    reducers:{
        setCloseCaptionText:(state,{payload})=>{
            state.closeCaptionText= payload.closeCaptionText
            state.ccBtns=payload.ccBtns
            state.showOriginalText=payload.showOriginalText
            state.fontSize=payload.fontSize
        }
    }
})

export const ccAction=ccSlice.actions;
export default ccSlice.reducer;